import React from "react";
import { Autocomplete, TextField, Checkbox, Button, Chip } from "@mui/material";
import { useBookmakers } from "../contexts/BookmakersContext";

const BookmakersFilter = () => {
  const { bookmakers, selectedBookmakers, setSelectedBookmakers } =
    useBookmakers();

  // Convert bookmakers object to an array of bookmaker names
  const bookmakerOptions = Object.keys(bookmakers);

  const handleSelectAllToggle = () => {
    if (selectedBookmakers.length === bookmakerOptions.length) {
      setSelectedBookmakers([]);
    } else {
      setSelectedBookmakers(bookmakerOptions);
    }
  };

  const renderTags = (value, getTagProps) =>
    value.length > 2
      ? [
          ...value
            .slice(0, 2)
            .map((option, index) => (
              <Chip
                key={option}
                {...getTagProps({ index })}
                label={option}
                size="small"
              />
            )),
          <Chip key="more" label={`+${value.length - 2} more`} size="small" />,
        ]
      : value.map((option, index) => (
          <Chip
            key={option}
            {...getTagProps({ index })}
            label={option}
            size="small"
          />
        ));

  return (
    <Autocomplete
      multiple
      sx={{ width: "100%" }}
      options={bookmakerOptions}
      value={selectedBookmakers}
      onChange={(event, newValue) => setSelectedBookmakers(newValue)}
      disableCloseOnSelect
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option}
        </li>
      )}
      renderTags={renderTags}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Bookmakers"
          placeholder="Select bookmakers"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                {selectedBookmakers.length !== bookmakerOptions.length && (
                  <Button onClick={handleSelectAllToggle}>All</Button>
                )}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default BookmakersFilter;
